import React, { useState, useEffect, useContext } from 'react';
import { 
  Button, List, ListItem, ListItemText, 
  Chip, CircularProgress  } from '@mui/material';
import TextField from '@mui/material/TextField'; 
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close'; // Import the close icon


import { useUser } from '../UserContext';
import { useCatalog } from '../CatalogContext';
import { loadCatalog } from '../Catalog/LoadCatalogButton';
import { MapContext } from '../MapContext';
import '../Topmenu.css';
import './Auth.css';

import { LayerContext} from '../LayerContext';
import { loadLayerAndDispatch } from '../SideBar/AddAssetButton'

const CatalogList = () => {
  const { map } = useContext(MapContext);
  const { dispatch } = useContext(LayerContext);
  const {user, setUser} = useUser();
  const {catalog, setCatalog} = useCatalog();
  
  const [catalogList, setCatalogList] = useState([]);
  const [catalogData, setCatalogData] = useState(null); // Store the parsed YAML data here
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState(''); // State for filter text
 
  const fetchDataList = async () => {
    try {
      const endpoint = process.env.REACT_APP_DATALIST_API_ENDPOINT;
      const res = await fetch(endpoint);
      const rawData = await res.json();
      const data = rawData['datasets'];
      
      // Filter out objects that don't have both 'id' and 'catalog' properties
      const filteredData = data.filter(
        item => 
          item.id !== undefined && 
          item.catalog !== undefined && 
          isUserAllowed(item, user)
      );
      setCatalogList(filteredData);
      console.log(filteredData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  
  useEffect(()=>{
    fetchDataList()
  }, [user])

  const handleCatalogClick = async (item) => {
    setIsLoading(true);
    const domain = `https://${item.id}.s3.amazonaws.com`;  
    const url = `${domain}/${item.catalog}`;
    try {
      const res = await loadCatalog(url);
      setCatalogData(res); // Store the parsed data in state
      setCatalog(res);
      addDefaultLayers(map.current, dispatch, res, item.id);
    } catch (error) {
      console.error('Error loading catalog:', error);
    }
    setIsLoading(false); 
  }
  
  const handleFilterChange = (event) => {
    setFilterText(event.target.value.toLowerCase());
  };
  // This function checks if the item matches the filter text
  const isItemMatchingFilter = (item) => {
    return Object.values(item).some(value =>
      value.toString().toLowerCase().includes(filterText)
    );
  };
  const handleClearInput = () => {
    setFilterText('');
  };

  return (
    <div className='topmenu-content'>
      <div className="currentCatalog">
        {user && catalog?.id ? 
        <div>
          <span>
            Current catalog: 
          </span>
          <Chip className="catalogChip" label={catalog?.id}/> 
        </div>
        :'No catalog selected'}
      </div>
      {isLoading && <div style={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></div>}
       <div style={{ margin: '10px 20px' }}>
        <TextField
          label="Filter Datasets"
          variant="outlined"
          fullWidth
          size="small"
          value={filterText}
          onChange={handleFilterChange}
          InputProps={{
            endAdornment: (
              filterText && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear input"
                    onClick={handleClearInput}
                    edge="end"
                  >
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              )
            ),
          }}
        />
      </div>
       <List style={{ 
        opacity: isLoading ? 0.2 : 1, 
        pointerEvents: isLoading ? 'none' : 'auto' 
      }}>
        {catalogList
          .filter(isItemMatchingFilter)
          .map(item => (
            <div key={item.id} className="catalog-div">
              <ListItem >
                  <Button onClick={()=> handleCatalogClick(item)}
                  variant="outlined" color="success" className="use-button"
                  > Use </Button>
                  <ListItemText primary={`${item.id}`}/>
              </ListItem>
              <div className="catalog-description" >
                <div>{item.desc }</div>
                <div>{item.catalog}</div>
              </div>
              {/* <ListItem > */}
              {/*   <ListItemText secondary={item.catalog} /> */}
              {/*     <Button variant="outlined" onClick={()=> handleCatalogClick(item)}> */}
              {/*       Use  */}
              {/*     </Button> */}
              {/* </ListItem> */}
              {/* <img key={`thumbnail-${item.id}`} src= {`https://cartoscope-thumbnails.s3.amazonaws.com/thumbnails/${item.id}.png`} /> */}
            </div>
        ))}
      </List>
    </div>
  );
}

const isUserAllowed = (dataset, user) => {
  let usergroups = [];
  let isUserAllowed = false;
  if (!user) {
    isUserAllowed = false;
  } else {
    usergroups = user.usergroups;
  }
  if (usergroups.indexOf("powerusers") >= 0) {
    isUserAllowed = true;
  }
  if (user && dataset.hasOwnProperty('isSample') && dataset.isSample) {
    isUserAllowed = true;
  }
  usergroups.forEach((usergroup) => {
    if (dataset.id === usergroup) {
      isUserAllowed = true;
    }
  });
  return isUserAllowed;
}

const addDefaultLayers = (map, dispatch, res, catalogId) =>{
  const defaults = ['hillshade.pmtiles', 'histology.pmtiles', '-hne.pmtiles'];
  if (res['assets'] && Array.isArray(res['assets']['basemap'])) {
    res['assets']['basemap'].forEach(url => {
      defaults.forEach(suffix => {
        if (url.endsWith(suffix)) {
          loadLayerAndDispatch(map, url, 'BACKGROUND', dispatch, true, catalogId);
        }
      });
    });
  }
}

export default CatalogList;
